
































































import { computed, defineComponent, onMounted, ref, useFetch, useRoute } from '@nuxtjs/composition-api';
import { map, sortBy, isEqual } from 'lodash-es';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import CollegeArticleFooterPC from '~/components/partials/College/CollegeArticleFooterPC.vue';
import CollegeArticleFooterSP from '~/components/partials/College/CollegeArticleFooterSP.vue';
import CollegeContentsList from '~/components/partials/College/CollegeContentsList.vue';
import CollegeHeader from '~/components/partials/College/CollegeHeader.vue';
import ContentDynamicComponent from '~/components/partials/Content/ContentDynamicComponent.vue';
import LayoutDefault from '~/components/partials/Layout/LayoutDefault.vue';
import { useCollege } from '~/composables/college/useCollege';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useLayoutProps } from '~/composables/useLayoutProps';
import { useStore } from '~/composables/useStore';
import { PageError } from '~/utils/error';
import { url } from '~/utils/url';
import { ArticleType, CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    LayoutDefault,
    AppIcon,
    AppLink,
    AppLoader,
    CollegeArticleFooterPC,
    CollegeArticleFooterSP,
    CollegeContentsList,
    CollegeHeader,
    ContentDynamicComponent,
  },
  setup() {
    const { isEnotecaAppWebView } = useEnotecaApp();
    const store = useStore();
    const route = useRoute();
    const routeParams = route.value.params;
    const { getLessonDetail } = useCollege();
    const tag = computed(() => (isEnotecaAppWebView.value ? 'a' : undefined));

    const isLoading = ref(true);
    const dynamicParts = ref<Array<any>>([]);
    const lessonTitle = computed(() => store.state.college.detail.lessonInfo.title);
    const articleList = ref<Array<{ isRead: boolean; title: string }>>([]);
    const pageTitle = ref<string>('');

    const { fetchState } = useFetch(async () => {
      try {
        // URL直打ちなどで講座情報をストアに格納できていない場合は、講座詳細を取得する
        if (!store.state.college.detail.lessonInfo.title || !store.state.college.detail.lessonInfo.articles.length) {
          await getLessonDetail(Number(routeParams.id), ArticleType.BasicLesson);
        }
        pageTitle.value = store.state.college.detail.lessonInfo.articles[Number(routeParams.page) - 1].title;

        store.state.college.detail.lessonInfo.articles.forEach((article) => {
          const data = { isRead: false, title: '' };
          if (store.state.auth.authenticated) {
            data.isRead = store.state.college.detail.readArticleIds.includes(article.id);
          }
          data.title = article.title;
          articleList.value.push(data);
        });

        isLoading.value = false;

        dynamicParts.value = await store.dispatch('college/detail/fetchLessonArticle', {
          articleType: ArticleType.BasicLessonPage,
          articleId: store.state.college.detail.lessonInfo.articles[Number(routeParams.page) - 1].id,
        });
      } catch {
        throw new PageError(404, {});
      }
    });

    onMounted(async () => {
      if (
        store.state.auth.authenticated &&
        store.state.college.detail.lessonInfo.articles[Number(routeParams.page) - 1]
      ) {
        // 未読だった場合、既読にする
        const articleId = store.state.college.detail.lessonInfo.articles[Number(routeParams.page) - 1].id;
        if (!articleId) return;
        if (!store.state.college.detail.readArticleIds.includes(articleId)) {
          await store.dispatch('college/detail/postReadLessonArticle', {
            lessonType: CollegeLessonType.BASIC,
            lessonId: Number(routeParams.id),
            articleId,
          });

          store.commit('college/detail/pushReadArticleId', articleId);
          // 講座の中の全ての読み物が既読になった場合、受講済みの受講ステータスを登録する
          if (
            isEqual(
              sortBy(store.state.college.detail.readArticleIds),
              sortBy(map(store.state.college.detail.lessonInfo.articles, 'id'))
            )
          ) {
            await store.dispatch('college/detail/putCompletedLessonStatus', {
              lessonType: CollegeLessonType.BASIC,
              lessonId: Number(routeParams.id),
            });
          }
        }
      }
    });

    useLayoutProps(() => ({
      layout: {
        header: isEnotecaAppWebView.value ? 'never' : 'always',
        headerMenu: 'never',
        helloBar: isEnotecaAppWebView.value ? 'never' : 'needed',
        footer: isEnotecaAppWebView.value ? 'never' : 'always',
        footerMenu: 'never',
      },
      head: {
        title: pageTitle.value,
      },
      fetchState,
    }));

    return {
      url,
      isEnotecaAppWebView,
      isLoading,
      lessonTitle,
      articleList,
      routeParams,
      dynamicParts,
      CollegeLessonType,
      tag,
    };
  },
});
